// jQuery(document).ready(function ($) {

//   function updateSocialHeight() {
//     let storeAttribute = $('.socialSiteName.active').data('video-id');
//     if (!storeAttribute) return;

//     let storeId = document.getElementById(storeAttribute);
//     if (!storeId) return;

//     let offHeight = storeId.offsetHeight - 40;
//     let newHeight = offHeight > 480 ? offHeight / 3 : 160;

//     $('.col2').children('.socialSiteName').css('height', newHeight);
//   }

//   $('.enviromentPageSlider').owlCarousel({
//     loop: false,
//     margin: 10,
//     nav: true,
//     responsive: {
//       0: { items: 1 },
//       600: { items: 1 },
//       1000: { items: 1 }
//     }
//   });

//   $('.privateLabPageSlider').owlCarousel({
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 4000,
//     dots: false,
//     smartSpeed: 500,
//     responsive: {
//       0: { items: 1 },
//       600: { items: 1 },
//       1000: { items: 1 }
//     }
//   });

//   $('.vimeoVideoText').on('click', function () {
//     let videoId = $(this).attr('data-video-id');

//     if ($('#' + videoId).hasClass('active')) return;

//     $('.vimeoVideo').fadeOut();
//     $('.vimeoVideo.active').removeClass('active');

//     $('#' + videoId).addClass('active').fadeIn();

//     $('.vimeoVideoText.active').removeClass('active');
//     $(this).addClass('active');
//   });

//   $('.socialSiteName').on('click', function () {
//     let videoId = $(this).attr('data-video-id');

//     if ($('#' + videoId).hasClass('socialActive')) return;

//     $('.socialFeed').fadeOut(400);
//     $('.socialFeed.socialActive').removeClass('socialActive');

//     $('#' + videoId).addClass('socialActive').fadeIn(400);

//     $('.socialSiteName.active').removeClass('active');
//     $(this).addClass('active');

//     setTimeout(updateSocialHeight, 200);
//   });

//   let check = setInterval(function () {
//     if ($('.eapps-instagram-feed-posts-view.eui-slider-slide').length > 0) {
//       updateSocialHeight();
//       clearInterval(check);
//     }
//   }, 2000);

// });
document.addEventListener('DOMContentLoaded', function () {

  function updateSocialHeight() {
    const activeSocial = document.querySelector('.socialSiteName.active');
    if (!activeSocial) return;

    const storeAttribute = activeSocial.getAttribute('data-video-id');
    if (!storeAttribute) return;

    const storeId = document.getElementById(storeAttribute);
    if (!storeId) return;

    const offHeight = storeId.offsetHeight - 40;
    const newHeight = offHeight > 480 ? offHeight / 3 : 160;

    document.querySelectorAll('.col2 > .socialSiteName').forEach(function (el) {
      el.style.height = newHeight + 'px';
    });
  }

  // owlCarousel is a jQuery plugin, so jQuery is still required for these two calls
  if (window.jQuery) {
    jQuery('.enviromentPageSlider').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
    });

    jQuery('.privateLabPageSlider').owlCarousel({
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      dots: false,
      smartSpeed: 500,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
    });
  }

  // Simple vanilla JS fade helpers (replacement for jQuery fadeOut/fadeIn)
  function fadeOut(el, duration = 400) {
    el.style.transition = `opacity ${duration}ms`;
    el.style.opacity = 1;
    requestAnimationFrame(() => {
      el.style.opacity = 0;
    });
    setTimeout(() => {
      el.style.display = 'none';
    }, duration);
  }

  function fadeIn(el, duration = 400) {
    el.style.transition = `opacity ${duration}ms`;
    el.style.display = '';
    el.style.opacity = 0;
    requestAnimationFrame(() => {
      el.style.opacity = 1;
    });
  }

  document.querySelectorAll('.vimeoVideoText').forEach(function (el) {
    el.addEventListener('click', function () {
      const videoId = this.getAttribute('data-video-id');
      const targetEl = document.getElementById(videoId);

      if (targetEl && targetEl.classList.contains('active')) return;

      document.querySelectorAll('.vimeoVideo').forEach(function (v) {
        fadeOut(v, 400);
      });

      const activeVideo = document.querySelector('.vimeoVideo.active');
      if (activeVideo) activeVideo.classList.remove('active');

      if (targetEl) {
        targetEl.classList.add('active');
        fadeIn(targetEl, 400);
      }

      const activeText = document.querySelector('.vimeoVideoText.active');
      if (activeText) activeText.classList.remove('active');

      this.classList.add('active');
    });
  });

  document.querySelectorAll('.socialSiteName').forEach(function (el) {
    el.addEventListener('click', function () {
      const videoId = this.getAttribute('data-video-id');
      const targetEl = document.getElementById(videoId);

      if (targetEl && targetEl.classList.contains('socialActive')) return;

      document.querySelectorAll('.socialFeed').forEach(function (s) {
        fadeOut(s, 400);
      });

      const activeFeed = document.querySelector('.socialFeed.socialActive');
      if (activeFeed) activeFeed.classList.remove('socialActive');

      if (targetEl) {
        targetEl.classList.add('socialActive');
        fadeIn(targetEl, 400);
      }

      const activeSite = document.querySelector('.socialSiteName.active');
      if (activeSite) activeSite.classList.remove('active');

      this.classList.add('active');

      setTimeout(updateSocialHeight, 200);
    });
  });

  let check = setInterval(function () {
    if (document.querySelectorAll('.eapps-instagram-feed-posts-view.eui-slider-slide').length > 0) {
      updateSocialHeight();
      clearInterval(check);
    }
  }, 2000);

});